import { Button } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "../../assets/scss/projects.scss";
import useHandleContextMenu from "../../hooks/useHandleContextMenu";
import { GetAntIcon } from "../../utils/ant_icons";
import { countryList } from "../../utils/countryCodes";
import Emitter from "../../utils/emitter";
import { checkPrivilege } from "../../utils/utils";
import PieChart from "../Charts/PieChart";
import ProjectCards from "./ProjectCards";
import usePermission from "../../hooks/usePermission";

const statusList = ["New", "In progress", "Resolved"];

function KanbanBoard(props: any) {
	const navigate = useNavigate();

	const { handleContextMenu } = useHandleContextMenu();
	const hasPermission = usePermission("Create.Project");

	const renderProjectStatusColumns = () => {
		return statusList.map((status: any) => {
			let filteredProjects = props.allProjects
				.filter((project: any) => {
					// if status is resolved, include projects that are closed
					if (status === "Resolved") {
						return project.closed === true || project.status === status;
					}
					return project.status === status && project.closed !== true;
				})
				.filter((project: any) => {
					const { searchValue, selectedFilters } = props;
					const {
						Type,
						"Project Area": ProjectArea,
						"Owner/Operator": Client,
						Region,
						Country,
						"Operating Office": OperatingOffice,
						Tags,
					} = selectedFilters;

					return (
						(searchValue === "" ||
							project.project_name
								.toLowerCase()
								.includes(searchValue.toLowerCase())) &&
						(Type?.length === 0 || Type?.includes(project.project_type)) &&
						(ProjectArea?.length === 0 ||
							ProjectArea?.includes(project.project_area)) &&
						(Client?.length === 0 || Client?.includes(project.client)) &&
						(Region?.length === 0 || Region?.includes(project.region)) &&
						(Country?.length === 0 || Country?.includes(project.country)) &&
						(OperatingOffice?.length === 0 ||
							OperatingOffice?.includes(project.operating_office)) &&
						((Array.isArray(Tags) && Tags?.length === 0) ||
							(Array.isArray(Tags) &&
								Tags.some((tag) => project?.project_tags?.includes(tag))))
					);
				})
				.sort((a: any, b: any) => {
					if (!props.sort) {
						return a.project_name.localeCompare(b.project_name);
					} else {
						return b.project_name.localeCompare(a.project_name);
					}
				});

			return (
				<div className="project-status-container">
					<div className="project-status-container-header">
						{GetAntIcon("square-check")} {status}
					</div>
					<div className="project-status-container-content">
						{status == "New" && hasPermission.hasPermission && (
							<Button
								className="add-new-project-button"
								type="primary"
								onClick={() => {
									// localStorage.setItem("currentProject", "Add new project");
									Emitter.emit("projectName", "Add new project");
									navigate("add-new-project", {
										replace: false,
									});
								}}
								onContextMenu={(e: any) => {
									const location = `${window.location.href}/add-new-project`;
									handleContextMenu(e, { link: location });
								}}
							>
								+ Add new project
							</Button>
						)}
						{filteredProjects.map((project: any) => {
							return (
								<ProjectCards
									project={project} // current iterated project
									sort={props.sort}
									allProjects={props.allProjects} // all projects from `props.allProjects`
									activeProjects={props.activeProjects}
									userRole={props.userRole}
									businessUnits={props.businessUnits}
									projectArea={props.projectArea}
									operatingOffices={props.operatingOffices}
									regions={props.regions}
									projectTags={props.projectTags}
									clients={props.clients}
									countries={countryList}
									setActiveProjects={props.setActiveProjects}
								/>
							);
						})}
					</div>
				</div>
			);
		});
	};

	return (
		<div className="kanban-board-container">
			<div className="kanban-columns-container">
				{renderProjectStatusColumns()}
			</div>
		</div>
	);
}

export default KanbanBoard;
